var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.initWebsocket}},[_vm._v("初始化")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }